class ProductGrid extends HTMLElement {
  constructor() {
    super();

    // ? sort by
    this.debounceShowSortByOptions = this.debounce(
      this.showSortByOptions.bind(this),
      100
    );
    this.debounceHideSortByOptions = this.debounce(
      this.hideSortByOptions.bind(this),
      100
    );
    this.debounceHandleSortBy = this.debounce(
      this.handleSortBy.bind(this),
      100
    );

    //? filter
    this.debounceShowFilterOptions = this.debounce(
      this.showFilterOptions.bind(this),
      100
    );
    this.debounceHideFiltersOptions = this.debounce(
      this.hideAllFilterOptions.bind(this),
      100
    );
    this.debounceHandleFilter = this.debounce(
      this.handleFilter.bind(this),
      100
    );

    //? active filter list li remove icon handler
    this.debounceRemoveFilter = this.debounce(
      this.handleRemoveFilter.bind(this),
      100
    );

    //? clear all btn
    this.debounceRemoveAllFilters = this.debounce(
      this.handleRemoveAllFilters.bind(this),
      100
    );

    //? mobile filter
    this.debounceShowMobileFilterOptions = this.debounce(
      this.showMobileFilterOptions.bind(this),
      100
    );

    this.debounceHideMobileFilterOptions = this.debounce(
      this.hideAllMobileFilterOptions.bind(this),
      100
    );

    this.debounceHandleMobileFilter = this.debounce(
      this.handleMobileFilter.bind(this),
      100
    );
  }

  connectedCallback() {
    this.init();
    this.sectionSettings = {
      showSortBy: this.getAttribute("data-show-sorting") === "true",
      showFilters: this.getAttribute("data-show-filters") === "true",
      showFilterName: this.getAttribute("data-show-filter-name") === "true",
      showBreadcrumbs: this.getAttribute("data-show-breadcrumbs") === "true",
      showBanner: this.getAttribute("data-show-banner") === "true",
      showTags: this.getAttribute("data-show-tags") === "true",
    };
  }

  init() {
    this.cacheDom();
    this.bindListeners();
  }

  cacheDom() {
    this.sortbyFilter = this.querySelector("#sort-by-filter");
    this.productFilters = this.querySelectorAll(".product-grid__filter");
    this.productMobileFilters = this.querySelectorAll(
      ".product-grid__mobile-filter"
    );
    this.productMobileFiltersWrapper = this.querySelector(
      ".product-grid__filters-list-mobile-scroll"
    );
    this.productMobileFiltersOptions = this.querySelectorAll(
      ".product-grid__mobile-filter-options"
    );
    this.productGridList = this.querySelector(".product-grid__list");
    this.productGridFooter = this.querySelector(".product-grid__footer");
    this.productGridHeader = this.querySelector(".product-grid__header");
  }

  bindListeners() {
    // Define outside to preserve function identity
    if (!this.boundClickHandler) {
      this.boundClickHandler = (e) => {
        if (e.target.closest(".sort-by__trigger")) {
          this.debounceShowSortByOptions(e);
          return;
        }

        if (e.target.closest(".sort-by__option")) {
          this.debounceHandleSortBy(e);
          return;
        }

        if (e.target.closest(".product-grid__filter-trigger")) {
          this.debounceShowFilterOptions(e);
          return;
        }

        if (e.target.closest(".product-grid__filter-option")) {
          this.debounceHandleFilter(e);
          return;
        }

        if (e.target.closest(".product-grid__mobile-filter-trigger")) {
          this.debounceShowMobileFilterOptions(e);
          return;
        }

        if (e.target.closest(".product-grid__mobile-filter-option")) {
          this.debounceHandleMobileFilter(e);
          return;
        }

        if (e.target.closest(".product-grid__active-filter-remove")) {
          this.debounceRemoveFilter(e);
          return;
        }

        if (e.target.closest(".product-grid__active-filter-clear")) {
          this.debounceRemoveAllFilters(e);
          return;
        }
      };
    }
    // Remove old event listener first (to avoid duplicates)
    this.removeEventListener("click", this.boundClickHandler);
    // Bind new event listener
    this.addEventListener("click", this.boundClickHandler);

    if (!this.boundDocumentClickHandler) {
      this.boundDocumentClickHandler = (e) => {
        if (!e.target.closest("#sort-by-filter")) {
          this.debounceHideSortByOptions(e);
        }
        if (!e.target.closest(".product-grid__filter")) {
          this.debounceHideFiltersOptions(e);
        }
        if (!e.target.closest(".product-grid__filters-list-mobile")) {
          this.debounceHideMobileFilterOptions(e);
        }
      };
    }

    // Rebind document clicks
    document.removeEventListener("click", this.boundDocumentClickHandler);
    // Bind new event listener
    document.addEventListener("click", this.boundDocumentClickHandler);

    if (!this.boundScrollHandler) {
      this.boundScrollHandler = () => {
        this.updateMobileFilterOptionOffSetLeft();
      };
    }

    // scroll
    // Remove old event listener first (to avoid duplicates)
    this.productMobileFiltersWrapper.removeEventListener(
      "scroll",
      this.boundScrollHandler
    );
    // Bind new event listener
    this.productMobileFiltersWrapper.addEventListener(
      "scroll",
      this.boundScrollHandler
    );
  }

  debounce(fn, delay) {
    let timer;
    return function (...args) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }

  //? handlers
  showSortByOptions(e) {
    //? hide all filter options
    this.hideAllFilterOptions();

    const triggerEl = e.target.closest(".sort-by__trigger");

    if (!triggerEl) {
      console.error("No trigger element found");
      return;
    }

    const sortByFilter = this.querySelector("#sort-by-filter");

    if (!sortByFilter) {
      console.error("No trigger element found");
      return;
    }

    const optionEl = sortByFilter.querySelector(".sort-by__options");

    if (!optionEl) {
      console.error("No option element found");
      return;
    }

    if (triggerEl.classList.contains("active")) {
      triggerEl.classList.remove("active");
      optionEl.classList.remove("show");
      optionEl.style.maxHeight = 0;
    } else {
      triggerEl.classList.add("active");
      optionEl.classList.add("show");
      optionEl.style.maxHeight = optionEl.scrollHeight + "px";
    }
  }

  showFilterOptions(e) {
    //? hide sort by options
    this.hideSortByOptions();

    const triggerEl = e.target.closest(".product-grid__filter-trigger");
    const optionEl = triggerEl.nextElementSibling;

    if (!triggerEl && !optionEl) {
      console.error("No trigger or option element found");
      return;
    }

    if (triggerEl.classList.contains("active")) {
      triggerEl.classList.remove("active");
      optionEl.classList.remove("show");
    } else {
      //? closed all other filter options
      this.hideAllFilterOptions();
      //? show current filter
      triggerEl.classList.add("active");
      optionEl.classList.add("show");
    }
  }

  showMobileFilterOptions(e) {
    //? hide sort by options
    this.hideSortByOptions();

    const triggerEl = e.target.closest(".product-grid__mobile-filter-trigger");
    const filterEl = triggerEl.closest(".product-grid__mobile-filter");
    const filterWrapperEl = filterEl.closest(
      ".product-grid__filters-list-mobile-scroll"
    );

    if (!triggerEl && !filterEl && !filterWrapperEl) {
      console.error("No trigger or option element found");
      return;
    }

    const optionEl = this.querySelector(
      `div[data-filter-id="${filterEl.getAttribute("id")}"]`
    );

    if (!optionEl) {
      console.error("No optionList element found");
      return;
    }

    const leftSide =
      triggerEl.getBoundingClientRect().left -
      filterWrapperEl.getBoundingClientRect().left;

    if (triggerEl.classList.contains("active")) {
      triggerEl.classList.remove("active");
      optionEl.classList.remove("show");
    } else {
      //? closed all other filter options
      this.hideAllMobileFilterOptions();
      //? show current filter
      triggerEl.classList.add("active");
      optionEl.classList.add("show");
      optionEl.style.width = triggerEl.offsetWidth + "px";
      optionEl.style.left = leftSide + "px";
    }
  }

  hideSortByOptions() {
    const triggerEl = this.querySelector(".sort-by__trigger");

    if (!triggerEl) {
      console.error("No trigger element found");
      return;
    }

    const sortByFilter = this.querySelector("#sort-by-filter");

    if (!sortByFilter) {
      console.error("No trigger element found");
      return;
    }

    const optionEl = sortByFilter.querySelector(".sort-by__options");

    if (!optionEl) {
      console.error("No option element found");
      return;
    }

    if (triggerEl.classList.contains("active")) {
      triggerEl.classList.remove("active");
      optionEl.classList.remove("show");
      optionEl.style.maxHeight = 0;
    }
  }

  hideAllFilterOptions() {
    this.productFilters.forEach((filter) => {
      const triggerEl = filter.querySelector(".product-grid__filter-trigger");
      const optionEl = triggerEl.nextElementSibling;
      triggerEl.classList.remove("active");
      optionEl.classList.remove("show");
    });
  }

  hideAllMobileFilterOptions() {
    this.productMobileFilters.forEach((filter) => {
      const triggerEl = filter.querySelector(
        ".product-grid__mobile-filter-trigger"
      );
      const optionEl = this.querySelector(
        `div[data-filter-id="${filter.getAttribute("id")}"]`
      );
      triggerEl.classList.remove("active");
      optionEl.classList.remove("show");
    });
  }

  handleSortBy(e) {
    const optionEl = e.target.closest(".sort-by__option");
    if (!optionEl) {
      console.error("No option element found");
      return;
    }
    //? get selected option
    const selectedOption = optionEl.getAttribute("data-value");
    //? update filter label and option
    this.updateSortByFilterState(selectedOption);
    //? update url state
    this.preserveUrlSearchParams("sort_by", selectedOption, false);
    //? apply sort by
    this.fetchCollection();
  }

  handleFilter(e) {
    const optionEl = e.target.closest(".product-grid__filter-option");
    if (!optionEl) {
      console.error("No option element found");
      return;
    }
    //? get selected option and param
    const selectedOption = optionEl.getAttribute("data-value");
    const param = optionEl.getAttribute("data-param");

    if (param === "tag") {
      const collectionUrl = optionEl.getAttribute("data-collection-url");
      this.handleTagOption(collectionUrl);
      return;
    }
    //? update url state
    this.preserveUrlSearchParams(param, selectedOption, true);
    //? apply filter
    this.fetchCollection();
  }

  handleMobileFilter(e) {
    const optionEl = e.target.closest(".product-grid__mobile-filter-option");

    if (!optionEl) {
      console.error("No option element found");
      return;
    }

    // //? get selected option and param
    const selectedOption = optionEl.getAttribute("data-value");
    const param = optionEl.getAttribute("data-param");

    if (param === "tag") {
      const collectionUrl = optionEl.getAttribute("data-collection-url");
      this.handleTagOption(collectionUrl);
      return;
    }

    // //? update url state
    this.preserveUrlSearchParams(param, selectedOption, true);
    // //? apply filter
    this.fetchCollection();
  }

  // ? active filter list li remove
  handleRemoveFilter(e) {
    const removeEl = e.target.closest(".product-grid__active-filter-remove");
    if (!removeEl) {
      console.error("No remove element found");
      return;
    }
    //? get selected option and param
    const param = removeEl.getAttribute("data-param");
    const value = removeEl.getAttribute("data-value");
    // const label = removeEl.getAttribute("data-filter-label");
    //? update url state
    this.preserveUrlSearchParams(param, value, true);
    //? apply filter
    this.fetchCollection();
  }

  //? clear all filters
  handleRemoveAllFilters() {
    const url = window.location.origin + window.location.pathname;
    window.history.replaceState({}, "", url);

    this.fetchCollection();
  }

  //? updates
  updateSortByFilterState(selectedOption) {
    const labelEl = this.sortbyFilter?.querySelector(
      ".sort-by__selected-value"
    );
    const labelOptions =
      this.sortbyFilter?.querySelectorAll(".sort-by__option");

    if (!labelEl && !labelOptions) {
      console.error("No label element or label options found");
      return;
    }

    // const search = new URLSearchParams(window.location.search);

    // const currentOption = selectedOption
    //   ? selectedOption
    //   : search.get("sort_by");

    // if (!currentOption) {
    //   return;
    // }
    labelOptions.forEach((option) => {
      option.classList.remove("active");
      if (option.getAttribute("data-value") === selectedOption) {
        option.classList.add("active");
        labelEl.textContent = option.textContent;
      }
    });
  }

  updateMobileFilterOptionOffSetLeft() {
    this.productMobileFiltersOptions.forEach((optionEl) => {
      if (optionEl.classList.contains("show")) {
        const filterId = optionEl.getAttribute("data-filter-id");
        this.productMobileFilters.forEach((filter) => {
          if (filter.getAttribute("id") === filterId) {
            const leftSide =
              filter.getBoundingClientRect().left -
              this.productMobileFiltersWrapper.getBoundingClientRect().left;
            optionEl.style.left = `${leftSide}px`;
          }
        });
      }
    });
  }

  handleTagOption(tagUrl) {
    window.location.href = `${window.location.origin}/collections/${tagUrl}`;
  }

  preserveUrlSearchParams(key, value, filterApplied = false) {
    const searchParams = new URLSearchParams(window.location.search);

    if (key !== "sort_by") {
      // Get all current values for this key
      const currentValues = searchParams.getAll(key);

      let newValues = [...currentValues];

      // Toggle logic: if already selected and clicked again, remove it — otherwise add
      const index = newValues.indexOf(value);
      if (index !== -1) {
        // Remove value (toggle off)
        newValues.splice(index, 1);
      } else {
        // Add value
        newValues.push(value);
      }

      // Delete all old entries for the key
      searchParams.delete(key);

      // Re-add updated values
      newValues.forEach((val) => searchParams.append(key, val));
    }

    if (key === "sort_by") {
      searchParams.set(key, value);
    }

    // Reset or remove 'page'
    if (filterApplied) {
      searchParams.set("page", 1);
    }
    if (searchParams.toString() === "page=1") {
      searchParams.delete("page");
    }

    // Push to URL
    const newUrl = `${window.location.origin}${window.location.pathname}${
      searchParams.toString() ? "?" + searchParams.toString() : ""
    }`;

    window.history.pushState({}, "", newUrl);
  }

  //? get collection handle
  getCollectionHandle(url) {
    try {
      const pathParts = url.split("/").filter(Boolean);
      const collectionIndex = pathParts.indexOf("collections");
      if (collectionIndex !== -1 && pathParts.length > collectionIndex + 1) {
        return pathParts.slice(collectionIndex + 1).join("/");
      }
      return null;
    } catch (error) {
      console.error("Error extracting collection handle:", error);
      return null;
    }
  }

  //? get collection filters
  getCollectionFilters() {
    const searchParams = new URLSearchParams(window.location.search);
    const shopifyParams = new URLSearchParams();

    searchParams.forEach((value, key) => {
      shopifyParams.append(key, value);
    });

    return shopifyParams.toString();
  }

  handleHiddenClasses() {
    const selectors = [
      "breadcrumbs",
      "banner",
      "filters",
      "sort-by",
      "active-filter-name",
    ];

    selectors.forEach((selector) => {
      let activeFilterNames;
      if (selector === "active-filter-name") {
        activeFilterNames = this.querySelectorAll(
          "span.product-grid__active-filter-name"
        );

        if (activeFilterNames.length === 0) {
          return;
        }

        activeFilterNames.forEach((name) => {
          name.classList.toggle("hidden", !this.sectionSettings.showFilterName);
        });

        return;
      }
      const element = this.querySelector(`#product-grid__${selector}`);

      switch (selector) {
        case "breadcrumbs":
          element.classList.toggle(
            "hidden",
            !this.sectionSettings.showBreadcrumbs
          );
          break;

        case "banner":
          element.classList.toggle("hidden", !this.sectionSettings.showBanner);
          break;

        case "filters":
          element.classList.toggle("hidden", !this.sectionSettings.showFilters);
          if (!this.sectionSettings.showTags) {
            const tagsFilterDesktop = element.querySelector(
              "#product-grid__filter--tag"
            );
            const tagsFilterMobile = element.querySelector(
              ".product-grid__mobile-filter--tag"
            );
            if (tagsFilterDesktop) {
              tagsFilterDesktop?.classList?.toggle(
                "hidden",
                !this.sectionSettings.showTags
              );
            }
            if (tagsFilterMobile) {
              tagsFilterMobile?.classList?.toggle(
                "hidden",
                !this.sectionSettings.showTags
              );
            }
          }
          break;

        case "sort-by":
          element.classList.toggle("hidden", !this.sectionSettings.showSortBy);
          break;

        default:
          break;
      }
    });
  }

  //? fetch collection
  async fetchCollection() {
    try {
      const collectionHandle = this.getCollectionHandle(
        window.location.pathname
      );
      const collectionFilters = this.getCollectionFilters();
      const response = await fetch(
        `/collections/${collectionHandle}?sections=collection-product-grid${
          collectionFilters.length > 0 ? `&${collectionFilters}` : ""
        }`
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch collection: ${response.status}`);
      }
      const data = await response.json();

      //? update product filters section
      const headerNewHtml = new DOMParser()
        .parseFromString(data["collection-product-grid"], "text/html")
        .querySelector(".product-grid__header")?.innerHTML;
      if (headerNewHtml) {
        this.productGridHeader.innerHTML = headerNewHtml;
      } else {
        this.productGridHeader.innerHTML = "";
      }

      //? update products grid list
      const productsListNewHtml = new DOMParser()
        .parseFromString(data["collection-product-grid"], "text/html")
        .querySelector(".product-grid__list")?.innerHTML;
      if (productsListNewHtml) {
        this.productGridList.innerHTML = productsListNewHtml;
      } else {
        this.productGridList.innerHTML = "";
      }

      //? if any products cardfound remove empty class from product list container
      if (productsListNewHtml) {
       const productCards = productsListNewHtml.match(/featured-collection__product/g) || [];
       const found = productCards.length > 0;
        if (found) {
          this.productGridList.classList.remove("product-grid__list--empty");
        } else {
          this.productGridList.classList.add("product-grid__list--empty");
        }
      }

      //? update product grid footer
      const footerNewHtml = new DOMParser()
        .parseFromString(data["collection-product-grid"], "text/html")
        .querySelector(".product-grid__footer")?.innerHTML;
      if (footerNewHtml) {
        this.productGridFooter.innerHTML = footerNewHtml;
      } else {
        this.productGridFooter.innerHTML = "";
      }

      this.handleHiddenClasses();

      this.init();
    } catch (error) {
      console.error("Error fetching collection:", error);
    }
  }

  //? disconnected callback
  disconnectedCallback() {
    this.removeEventListener("click", this.boundClickHandler);
    document.addEventListener("click", this.boundDocumentClickHandler);
    this.productMobileFiltersWrapper.removeEventListener(
      "scroll",
      this.boundScrollHandler
    );
  }
}

customElements.define("product-grid", ProductGrid);
